import React, { Component, useRef } from 'react';
import '../StoreSelector.css';
import './NewStoreSelector.css';
import { setCursorStyle } from '../../../../utils/MouseUtilities.js';
import Segment from 'semantic-ui-react/dist/es/elements/Segment';
import 'semantic-ui-css/components/segment.min.css';
import 'semantic-ui-css/components/image.min.css';

const hoverCursorStyle = 'pointer';
const unhoverCursorStyle = 'all-scroll';
import { Accordion } from 'semantic-ui-react';
import { NavigationMenuOptionClicked, StoreSelectorOption } from '../../../../utils/Analytics.js';
import SVGImage from '../../image-components/SVGImage';
import { getAllSceneInfoDictAsync } from '../../../../utils/StoreConfigManager';
import { AppContext } from '../../../../AppContext.jsx';
import { ThreeJSWorldContext } from 'web-store-modules/packages/web-store-three-world';
import MenuItem from './MenuItem';
import { getDirectoryMenu } from '../../../../utils/StaticAssetManager';
import ReactHtmlParser from 'react-html-parser';

const dropDownArrowIcon = "https://cdn.obsess-vr.com/vacheron/arrow-down.png";
const linkedRandomScenes = () => {
    return [
        {
            name: 'Entrance',
            scene_id: '5f7f9387018459df66ca47ea'
        },
        {
            name: 'Terrace',
            scene_id: '5f74fa8bf9ea02eb4c350a65'
        },
        {
            name: 'Living Room',
            scene_id: '5f7b94228b1d14ab9ebf01f1'
        },
        {
            name: 'Bedroom',
            scene_id: '5f74fee562108b77cfe300a4'
        },
        {
            name: 'Dressing Room',
            scene_id: '5f8a11b62744fbe58e679f52'
        },
        {
            name: 'Entrance',
            scene_id: '5f7f9387018459df66ca47ea'
        },
        {
            name: 'Terrace',
            scene_id: '5f74fa8bf9ea02eb4c350a65'
        },
        {
            name: 'Living Room',
            scene_id: '5f7b94228b1d14ab9ebf01f1'
        }
    ]
}
class CurrentStoreMenuItem extends Component {
    constructor(props) {
        super(props);

        this.onHover = this.onHover.bind(this);
        this.onUnhover = this.onUnhover.bind(this);
        this.onClick = this.onClick.bind(this);

        this.state = {
            jumpToFont: 'https://s3.amazonaws.com/obsessvr-webstore-assets-public/Caslon-BookItalic.otf',
            placeholderIconSrc: 'https://s3.amazonaws.com/obsessvr-webstore-assets-public/placeholder.svg',
            currentStoreMenuItemColor: '#7d7e7e',
            sections:[],
            activeIndex:''
        }

    }

    componentDidMount() {
        this.setState({sections: getDirectoryMenu()})
    }

    onHover() {
        setCursorStyle(hoverCursorStyle);
    }

    onUnhover() {
        setCursorStyle(unhoverCursorStyle);
    }

    onClick(sceneId,sceneName,categoryIndex) {
        const { threeJSWorldContext, setLoadingIconVisibility, closeMenu } = this.props;
        const { controller, history } = threeJSWorldContext;
        const { sections } = this.state; 
        setLoadingIconVisibility(true);
        closeMenu();
        getAllSceneInfoDictAsync()
            .then(sceneInfoDict => {
                if (!sceneInfoDict[sceneId]) {
                    throw new Error('Scene with id ' + sceneId + ' do not exist!');
                }

                const linkedSceneName = sceneInfoDict[sceneId]['name'];
                sections[categoryIndex]?.name
                let targetPath = '/' + linkedSceneName;
                StoreSelectorOption(linkedSceneName);
                if (threeJSWorldContext.history.location.pathname !== targetPath) {
                    history.push(targetPath)
                    controller.controller.reset();
                } else {
                    this.props.setLoadingIconVisibility(false);
                }
            })
    }

    handleClick = (e, titleProps) => {
        const { sections } = this.state; 
        const { index } = titleProps;
        NavigationMenuOptionClicked(sections[index]?.name);
        const { activeIndex } = this.state
        const newIndex = activeIndex === index ? -1 : index
        this.setState({ activeIndex: newIndex })
    }

    render() {
        const { currentStoreMenuItemColor, placeholderIconSrc, sections, activeIndex } = this.state;
        const { menuTextFontStyle, store, currentScene } = this.props;

        let style = Object.assign({}, menuTextFontStyle);
        let sceneStyle = Object.assign({}, menuTextFontStyle);

        style.color = currentStoreMenuItemColor;
        const routeRenders = sections.map((scene, index) => {
            let submenuArr = [];
            scene?.submenu.map(function (el) { return submenuArr.push(el?.sceneId); });
            return (<Accordion key={index}>
                <React.Fragment key={index}>
                    {scene.isHeader ?
                        <Accordion.Title
                            active={activeIndex === index}
                            index={index}
                            onClick={this.handleClick}
                            key={index}
                        >
                            <div className='linked-store-scene' onClick={() => scene.type ? this.openModal(scene.type) : scene.redirecturl ? this.redirectTo(scene.redirecturl) : scene.sceneId && !scene.haveItems && this.onClick(scene.sceneId)}>
                                <span
                                    className={(currentScene === scene.sceneId && scene.sceneId != '' ? 'active-section' : '')}
                                    onMouseOver={this.onHover}
                                    onMouseOut={this.onUnhover}
                                    onClick={() => scene.sceneId && this.onClick(scene.sceneId)}
                                    style={{ color: submenuArr.includes(currentScene) ? '#787777' : null}}
                                > {ReactHtmlParser(scene.name)}</span>
                                {scene.haveItems ?
                                    <img src={dropDownArrowIcon}
                                        className="dropdown-arrow-style"
                                        style={{ transform: activeIndex === index ? 'rotate(360deg)' : '' }} /> : ''
                                }
                            </div>
                        </Accordion.Title>
                        : ""
                    }
                    {scene.submenu &&
                        scene.submenu.map((item, i) => {
                            return (
                                <Accordion.Content active={activeIndex === index} key={i}>
                                    <div className='linked-store-subsection' onClick={() => item.sceneId && this.onClick(item.sceneId,item.name,index)}>
                                        <span
                                            className={(currentScene === item.sceneId && item.sceneId != '' ? 'active-section' : '')}
                                            onMouseOver={this.onHover}
                                            onMouseOut={this.onUnhover}
                                        > {item.name}</span>
                                    </div>
                                </Accordion.Content>
                            )
                        })
                    }
                </React.Fragment>
            </Accordion>)
        });


        return (
            <Segment className="overflow-auto">
                <div className="text-align-left float-left">
                    {routeRenders}
                </div>
                <div
                    style={{ float: 'right', marginTop: '-0.5em' }}
                >
                </div>
            </Segment>
        );
    }
}

CurrentStoreMenuItem.propTypes = {
    closeMenu: PropTypes.func,
    menuTextFontStyle: PropTypes.object,
    store: PropTypes.object,
    setLoadingIconVisibility: PropTypes.func
};

export default props => (
    <AppContext.Consumer>
        {appContextValue => (
            <ThreeJSWorldContext.Consumer>
                {threeJSWorldContext => (
                    <CurrentStoreMenuItem
                        {...props}
                        threeJSWorldContext={threeJSWorldContext}
                        setLoadingIconVisibility={appContextValue.setLoadingIconVisibility}
                        currentScene={appContextValue.currentScene}
                    />
                )}
            </ThreeJSWorldContext.Consumer>
        )}
    </AppContext.Consumer>
);
